import {BaseContainerModel} from '../base-container.model';
import {bl_mrp_process_instance_hdr_RowClass} from '../../dbschema/bl_mrp_process_instance_hdr.model';

export class MrpProcessInstanceHdrContainerModel extends BaseContainerModel {
  bl_mrp_process_instance_hdr:  bl_mrp_process_instance_hdr_RowClass = new  bl_mrp_process_instance_hdr_RowClass();
}
